import React from 'react';
import Overlay from 'Components/Overlay';
import Dropdown from 'Components/Dropdown/index';

const UpdateStatusVisibility = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter">
            <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {'Bidding Status Visibility'} 
            </div>
            <div className='tCenter mt-10'>
                <Dropdown
                    items={props.vendorBiddingStatus}
                    label="Select Status" 
                    displayKey="name" 
                    selectedItem={props.vendorBiddingStatus.find((el)=> {
                          return el.id === (props.data || {}).vendor_bidding_screen_id
                    })}
                    onSelect = {props.onChange}
                    className="mb-30 wt-250 ml-50"
                />
            </div>
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>Cancel</button>
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onSave}>Save</button>
            </div>
        </div>
    </Overlay>
);

export default UpdateStatusVisibility;